import { useFormik } from "formik";
import React from "react";
import { useState } from "react";
import FPPage_1 from "../Forgotpassword/FPPage_1";
import FPPage_2 from "../Forgotpassword/FPPage_2";
import { ForgotPasswordEmailValidation, ResetPasswordValidation } from "../../components/Validation";
import { ForgotPasswordChangepasswordApi, ForgotPasswordsendotpApi, ForgotPasswordVerifyotpApi } from "../../apis";
import toast from "react-hot-toast";
import FPPage_3 from "../Forgotpassword/FPPage_3";


export default function ForgotPasswordScreens({BacktoSignin}) {
    const [passwordType, setPasswordType] = useState('password');
    const [confirmPasswordType, setConfirmPasswordType] = useState('password');
    const [forgotPasswordBlock, setForgotPasswordBlock] = useState(1);
    const [loader, setLoader] = useState(false);
    const [isWrongOtp, setIsWrongOtp] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [otp, setOTP] = useState('');
    const handleOtpInput = (otp) => {
        setIsWrongOtp(false);
        setErrorMsg('');
        setOTP(otp);
    };
    function handelPasswordType() {
        if (passwordType == 'text') {
            setPasswordType('password');
        } else if (passwordType == 'password') {
            setPasswordType('text');
        }
    }
    function handelConfirmPasswordType() {
        if (confirmPasswordType == 'text') {
            setConfirmPasswordType('password');
        } else if (confirmPasswordType == 'password') {
            setConfirmPasswordType('text');
        }
    }
    function handelForgotPasswordBlocks(prop) {
        setForgotPasswordBlock(prop);
    }

    //formik declaration 
    const formik = useFormik({
        initialValues: { email: '' },
        validationSchema: ForgotPasswordEmailValidation,
        onSubmit: async (values) => {
            const { email } = values;
            try {
                setLoader(true);
                const res = await ForgotPasswordsendotpApi({ email });
                if (res.status === 200) {
                    toast.success(res.data.message);
                    handelForgotPasswordBlocks(2);
                }
            } catch (error) {
                setLoader(false);
                const message =
                    error.response.data.message || error.response.statusText;
                toast.error(message, { id: 'error' });
            } finally {
                setLoader(false);
            }
        },
    });
    const formik2 = useFormik({
        initialValues: { otp: '' },
        onSubmit: async (values) => {
            const { email } = formik.values;
            if (otp.length < 4) {
                setIsWrongOtp(true);
                setErrorMsg('Please enter 6 digits otp');
                return;
            }
            try {
                setLoader(true);
                const res = await ForgotPasswordVerifyotpApi({
                    email: email,
                    otp: otp,
                });
                if (res.status === 200) {
                    toast.success(res.data.message);
                    formik3.setFieldValue('userid', res.data?.user?._id);
                    handelForgotPasswordBlocks(3);
                }
            } catch (error) {
                setLoader(false);
                const message =
                    error.response.data.message || error.response.statusText;
                toast.error(message, { id: 'error' });
            } finally {
                setLoader(false);
            }
        },
    });
    const formik3 = useFormik({
        initialValues: { newpassword: '', confirmpassword: '', userid: '' },
        validationSchema: ResetPasswordValidation,
        onSubmit: async (values) => {
            const { newpassword, userid } = values;
            try {
                setLoader(true);
                const res = await ForgotPasswordChangepasswordApi({
                    userId: userid,
                    password: newpassword,
                });
                if (res.status === 200) {
                    toast.success(res.data.message);
                    BacktoSignin();
                }
            } catch (error) {
                console.log(error)
                setLoader(false);
                const message =
                    error.response.data.message || error.response.statusText;
                toast.error(message, { id: 'error' });
            } finally {
                setLoader(false);
            }
        },
    });


    return (
        <div className="mt-2 mb-[35px] mx-5">
            {forgotPasswordBlock == 1 ? (
                <>
                    <FPPage_1
                        formik={formik}
                        loader={loader}
                        setLoader={setLoader}
                        BacktoSignin={()=>{BacktoSignin()}}
                    />
                </>
            ) : forgotPasswordBlock == 2 ? (
                <FPPage_2
                    formik={formik2}
                    email={formik.values.email}
                    handleOtpInput={(otp) => { handleOtpInput(otp) }}
                    loader={loader}
                    setLoader={setLoader}
                    isWrongOtp={isWrongOtp}
                    otp={otp}
                    BacktoSignin={()=>{BacktoSignin()}}
                />

            ) : forgotPasswordBlock == 3 ? (
                <FPPage_3
                    passwordType={passwordType}
                    loader={loader}
                    setLoader={setLoader}
                    formik3={formik3}
                    handelPasswordType={() => { handelPasswordType() }}
                    confirmPasswordType={confirmPasswordType}
                    handelConfirmPasswordType={() => { handelConfirmPasswordType() }}
                    BacktoSignin={()=>{BacktoSignin()}}
                />
            ) : (
                <></>
            )}
        </div>
    );
}